import React from 'react';
import { InsidePagesCarousel } from '../InsidePagesCarousel';
import { SectionHeading } from './SectionHeading';
export function InsideSection() {
  return <section aria-labelledby="inside-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-20" data-id="element-127" data-mp="2lz7ysq8p4ia3">
      <div className="mx-auto max-w-6xl" data-id="element-128" data-mp="2h424p4553xax">
        <SectionHeading id="inside-heading" title="Guarda cosa troverai all'interno!" body="Materiali concreti per insegnare tecniche professionali, guidare la pratica e valutare le competenze delle tue allieve." data-id="element-129" data-mp="2d5mk16wj710o" />

        <div className="mt-12" data-id="element-130" data-mp="23902aqzi4q2v">
          <InsidePagesCarousel data-id="element-131" data-mp="1y70yxh3rht5x" />
        </div>

        <p className="mt-6 text-center font-body text-[13px] italic text-brand-charcoal/55" data-id="element-132" data-mp="1y7u8sqy0oysa">
          Pagine reali dal Volume 2 di Lash & Brow Instructor Ready™ · Tocca una pagina per ingrandirla
        </p>
      </div>
    </section>;
}